import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <p>Crazy craft</p>
    </div>
  );
}

export default App;
